module.exports = __webpack_public_path__ + "static/media/custom-5000-high.7e9eea40.svg";